// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"b1b59606","67":"1a84699e","94":"04fbacb9","134":"bb94fe4d","204":"caf5ff33","338":"c2daa6c5","372":"0d904987","376":"57e4bde1","378":"8c6a6bf7","406":"93523216","648":"08b10666","671":"2d21ef3e","712":"9707e4b6","718":"98bb4f8b","893":"ff0c4b8e","913":"98216967"}[chunkId] + ".chunk.js";
};